export const auStrings = {
  code: "AU",
  logo: "logo-au",

  footerSocialLinks: {
    facebook: {
      href: "https://www.facebook.com/latitudefinancialservices",
      title: "Latitude Financial Facebook",
    },
    twitter: {
      href: "https://www.twitter.com/Latitude_FS",
      title: "Latitude Financial Twitter",
    },
    instagram: {
      href: "https://www.instagram.com/Latitude_FS",
      title: "Latitude Financial Instagram",
    },
    linkedin: {
      href: "https://www.linkedin.com/company/latitude-financial-services",
      title: "Latitude Financial Linked In",
    },
  },

  footerLegalLinks: [
    {
      text: "Privacy and Credit Reporting Policy",
      href: "https://www.latitudefinancial.com.au/privacy/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Privacy and Credit Reporting Policy",
      },
    },
    {
      text: "Security",
      href: "https://www.latitudefinancial.com.au/security/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Security",
      },
    },
    {
      text: "Complaints",
      href: "https://assets.latitudefinancial.com/brochures/au/complaints-brochure.pdf",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Complaints",
      },
    },
    {
      text: "Financial Hardship",
      href: "https://www.latitudefinancial.com.au/hardship/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Financial Hardship",
      },
    },
  ],

  relayServiceTitle: "National Relay Service",
  relayServiceLink:
    "https://www.communications.gov.au/what-we-do/phone/services-people-disability/accesshub",
  complaints: "https://www.latitudefinancial.com.au/complaints",
  covidInformation: "https://www.latitudefinancial.com.au/covid-19",
};

export const nzStrings = {
  code: "NZ",
  logo: "logo-nz",

  footerSocialLinks: {
    facebook: {
      href: "https://www.facebook.com/GemFinance",
      title: "Gem Finance Facebook",
    },
    youtube: {
      href: "https://www.youtube.com/channel/UC4OODvUJswoDRTS_xFCCXcw",
      title: "Gem Finance YouTube",
    },
    twitter: {
      href: "https://www.twitter.com/Latitude_FS",
      title: "Latitude Financial Twitter",
    },
    instagram: {
      href: "https://www.instagram.com/gem_finance",
      title: "Gem Finance Instagram",
    },
    linkedin: {
      href: "https://www.linkedin.com/company/latitude-financial-services",
      title: "Latitude Financial Linked In",
    },
  },

  footerLegalLinks: [
    {
      text: "Privacy and Credit Reporting Policy",
      href: "https://www.gemfinance.co.nz/privacy/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Privacy and Credit Reporting Policy",
      },
    },
    {
      text: "Security",
      href: "https://www.gemfinance.co.nz/security/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Security",
      },
    },
    {
      text: "Complaints",
      href: "https://www.gemfinance.co.nz/complaints/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Complaints",
      },
    },
    {
      text: "Financial Hardship",
      href: "https://www.gemfinance.co.nz/hardship/",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Financial Hardship",
      },
    },
    {
      text: "Prescribed Disclosure Statement",
      href: "https://assets.latitudefinancial.com/legals/product-disclosure-statements/nz/pds.pdf",
      eventData: {
        category: "text-link",
        action: "internal-link",
        location: "footer",
        label: "Prescribed Disclosure Statement",
      },
    },
  ],

  relayServiceTitle: "NZ Relay Service",
  relayServiceLink: "https://www.nzrelay.co.nz",
  complaints: "https://www.gemfinance.co.nz/complaints",
  covidInformation: "https://www.gemfinance.co.nz/covid-19",
};
